/** The `treeWebTx_familyOrdinanceView` treatment without the Personal tab. */
export const FAMILY_TABS_ONLY_TREATMENT = 'familyTabsOnly'
